export function escapeHtml(text) {
  return String(text ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;");
}

export function pad2(n) {
  return String(n).padStart(2, "0");
}

export function createPdfFileName(prefix, date = new Date()) {
  return `${prefix}-${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}-${pad2(date.getHours())}-${pad2(date.getMinutes())}.pdf`;
}

export function printHtmlAsPdf({ html, title }) {
  const printFrame = document.createElement("iframe");
  printFrame.style.position = "fixed";
  printFrame.style.right = "0";
  printFrame.style.bottom = "0";
  printFrame.style.width = "0";
  printFrame.style.height = "0";
  printFrame.style.border = "0";
  printFrame.style.opacity = "0";
  printFrame.setAttribute("aria-hidden", "true");
  document.body.appendChild(printFrame);

  const frameWindow = printFrame.contentWindow;
  const frameDoc = frameWindow?.document;
  if (!frameWindow || !frameDoc) {
    document.body.removeChild(printFrame);
    return;
  }

  frameDoc.open();
  frameDoc.write(`<!doctype html><html><head><title>${escapeHtml(title)}</title></head><body>${html}</body></html>`);
  frameDoc.close();

  frameWindow.onload = async () => {
    try {
      if (typeof frameWindow.__preparePdf === "function") {
        await Promise.race([
          frameWindow.__preparePdf(),
          new Promise((resolve) => window.setTimeout(resolve, 1200)),
        ]);
      }
    } catch (error) {
      // Fall back to normal print flow when pre-rendering fails.
    }
    frameWindow.focus();
    frameWindow.print();
    window.setTimeout(() => {
      if (document.body.contains(printFrame)) document.body.removeChild(printFrame);
    }, 800);
  };
}
